export const ADMIN_SIDEBAR_WIDTH_CLASSES = Object.freeze({
  compact: 'w-[88px]',
  expanded: 'w-[264px]',
});

const ADMIN_MAIN_OFFSET_CLASSES = Object.freeze({
  compact: 'admin-desktop:ml-[88px]',
  expanded: 'admin-desktop:ml-[264px]',
  overlay: '',
});

const ADMIN_HEADER_OFFSET_CLASSES = Object.freeze({
  compact: 'admin-desktop:left-[88px]',
  expanded: 'admin-desktop:left-[264px]',
  overlay: '',
});

// Sidebar, fixed header, and main content all derive their width/offset from
// this single contract so an expanding Rail remains in flow instead of
// painting over the page.
export const getAdminShellGeometry = (sidebarMode, railExpanded = false) => {
  const overlay = sidebarMode === 'overlay';
  const expanded = sidebarMode === 'pinned' || (sidebarMode === 'rail' && railExpanded);
  const size = expanded ? 'expanded' : 'compact';

  return Object.freeze({
    sidebarWidthClass: ADMIN_SIDEBAR_WIDTH_CLASSES[overlay ? 'expanded' : size],
    mainOffsetClass: ADMIN_MAIN_OFFSET_CLASSES[overlay ? 'overlay' : size],
    headerOffsetClass: ADMIN_HEADER_OFFSET_CLASSES[overlay ? 'overlay' : size],
  });
};
